import { useState, useEffect } from "react";
import { useGetAllPaymentModeQuery } from "src/services/PaymentModeService";

const usePaymentModes = () => {
    const [paymentMode, setPaymentMode] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllPaymentModeQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setPaymentMode(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { paymentMode, isDataLoading };
};

export default usePaymentModes;
